var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47656 18.3505L10.5766 20.7505C10.9766 21.1505 11.8766 21.3505 12.4766 21.3505H16.2766C17.4766 21.3505 18.7766 20.4505 19.0766 19.2505L21.4766 11.9505C21.9766 10.5505 21.0766 9.35046 19.5766 9.35046H15.5766C14.9766 9.35046 14.4766 8.85046 14.5766 8.15046L15.0766 4.95046C15.2766 4.05046 14.6766 3.05046 13.7766 2.75046C12.9766 2.45046 11.9766 2.85046 11.5766 3.45046L7.47656 9.55046",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38281 18.3504V8.55039C2.38281 7.15039 2.98281 6.65039 4.38281 6.65039H5.38281C6.78281 6.65039 7.38281 7.15039 7.38281 8.55039V18.3504C7.38281 19.7504 6.78281 20.2504 5.38281 20.2504H4.38281C2.98281 20.2504 2.38281 19.7504 2.38281 18.3504Z",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.26958e30397c01e9b655758e5dee5046.svg";
export { ForwardRef as ReactComponent };